/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumnorderedat4Inputs */

const en_ticketpagecolumnorderedat4 = /** @type {(inputs: Ticketpagecolumnorderedat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordered`)
};

const de_ticketpagecolumnorderedat4 = /** @type {(inputs: Ticketpagecolumnorderedat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellt am`)
};

/**
* | output |
* | --- |
* | "Ordered" |
*
* @param {Ticketpagecolumnorderedat4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumnorderedat4 = /** @type {((inputs?: Ticketpagecolumnorderedat4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumnorderedat4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumnorderedat4(inputs)
	return de_ticketpagecolumnorderedat4(inputs)
});
export { ticketpagecolumnorderedat4 as "ticketPageColumnOrderedAt" }